/* eslint-disable */
import "jquery-match-height";
import "owl.carousel";

import { setPaddings, setPagination } from './utils';

export default {
  init() {

    const testimonialSliderOptions = {
      loop: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 6500,
      singleItem: false,
      stagePadding: 0,
      autoWidth: false,
      smartSpeed: 1050,
      dotsContainer: '#testimonial-dots',
      responsive: {
        0: {
          margin:0,
          items:1,
          slideBy:1,
          dots:false,
        },
        992: {
          dots: true,
          margin:200,
          slideBy:2,
          items:2,
        },
      },
    };
    $("#testimonial-slider").owlCarousel(testimonialSliderOptions).trigger("refresh.owl.carousel");

    const heroBannerOptions = {
      loop: true,
      nav: false,
      autoplay: true,
      autoplayTimeout: 6500,
      margin:0,
      singleItem: true,
      stagePadding: 0,
      autoWidth: false,
      smartSpeed: 1050,
      slideBy: 1,
      items:1,
      responsive: {
        0: {
          dots: false,
        },
        992: {
          dotsContainer: '#hero-dots',
          dots: true,
        }
      }
    };
    $("#hero-banner").owlCarousel(heroBannerOptions).trigger("refresh.owl.carousel");

    const inlineGalleryItems = $('#inline-gallery .slider-item');
    console.log(inlineGalleryItems.length);
    const inlineGalleryOptions = {
      loop: true,
      nav: inlineGalleryItems.length !== 1,
      navText: ['<i class="icon-arrow"></i>', '<i class="icon-arrow"></i>'],
      navContainer: '.inline-gallery-wrapper',
      dots: inlineGalleryItems.length !== 1,
      dotsContainer: '#inline-dots',
      autoplay: true,
      autoplayTimeout: 6500,
      margin:0,
      singleItem: true,
      stagePadding: 0,
      autoWidth: false,
      smartSpeed: 1050,
      slideBy: 1,
      items:1,
    };
    $("#inline-gallery").owlCarousel(inlineGalleryOptions).trigger("refresh.owl.carousel");

    const logoSliderOptions = {
      loop: true,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 4500,
      margin: 10,
      singleItem: false,
      stagePadding: 0,
      autoWidth: false,
      smartSpeed: 1050,
      responsive: {
        0: {
          items:1,
          slideBy: 1,
        },
        768: {
          items:2,
          slideBy: 2,
        },
        992: {
          items: 4,
          slideBy: 4,
        },
        1200: {
          slideBy: 5,
          items: 5,
        }
      }
    };
    $("#logo-slider").owlCarousel(logoSliderOptions).trigger("refresh.owl.carousel");



    $('#mainHeader .main-menu > li.menu-item-has-children').each(function() {
      const menuItem = $(this);
      const subMenu = menuItem.find('.sub-menu');
      const itemsWrapper = $('#megaMenu ul.items');
      subMenu.find('li').each(function() {
        const item = $(this);
        const imageUrl = item.children('a').children('img').attr('src');
        const title = item.children('a').children('span').html();
        const url = item.children('a').attr('href');
        const activeClass = item.hasClass('current-menu-item') ? 'active' : '';
        itemsWrapper.append('<li class="'+activeClass+'"><a href="'+url+'"><div class="image" style="background-image:url('+imageUrl+');"></div><div class="title">'+title+'</div></a></li>');
      });
    });


    $('#mainHeader .main-menu > li > a[href="#"]').on('click', function(e) {
      e.preventDefault();
      $('#megaMenu').slideToggle();
    });

    $('.sections-nav-responsive > li > a').on('click', function(e){
      e.preventDefault();
      $('.body-wrapper').animate({
        scrollTop: $($(this).attr('href')).offset().top
      }, 1000);
    });

    $('.sections-navigation-wrapper .wrap .sections-navigation > li > a').on('click', function(e){
      e.preventDefault();
      if (!$(this).hasClass('active')) {
        $('.sections-navigation-wrapper .wrap .sections-navigation > li > a').removeClass('active');
        $(this).addClass('active');
        const elementId = $(this).attr('href').substr(1);
        const element = document.getElementById(elementId);
        element.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });

        /*$('.body-wrapper').animate({
          scrollTop: $($(this).attr('href')).offset().top
        }, 1000);*/
      }
    });

    $('#mainHeader .menuWrap .burger-button').on('click', function(){
      $('#mainHeader').toggleClass('menu-open');
      $(this).toggleClass('open');
      $('#responsive-menu-wrap').slideToggle();
    });

    $("#callbackButton").on('click', function() {
      const contactSection = document.getElementById('contactWrap');
      contactSection.scrollIntoView({
        block: "center",
        behavior: "smooth"
      });
      /*$('.body-wrapper, html, body').animate({
        scrollTop: $("#contactWrap").offset().top
      }, 1000);*/
    });

    $('#responsive-menu-wrap .responsive-menu > li > a[href="#"]').on('click', function(e){
      e.preventDefault();
      $(this).parent('li').children('.sub-menu').slideToggle();
    });

    $('.sections-nav-responsive > li .toggle').on('click', function(){
      $(this).toggleClass('open');
      $('.sections-nav-responsive > li').not(':first-child').fadeToggle();
    });

  },
  finalize() {
    $(window).load(function() {
      setPaddings();
      setPagination();

      $(".body-wrapper").removeClass("lock");
      $("#logo-slider").trigger("refresh.owl.carousel");
      $("#testimonial-slider").trigger("refresh.owl.carousel");
      $("#hero-banner").trigger("refresh.owl.carousel");
      $("#inline-gallery").trigger("refresh.owl.carousel");

      $.fn.matchHeight._update();
      $(".initial-hidden").css("opacity", 1);
    });

    $.fn.matchHeight._update();

    $(window).resize(function() {
      setPaddings();
      $.fn.matchHeight._update();
    });
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js